import { Flex, Box, Tag, Text } from "@chakra-ui/react";
import { ColumnType } from "antd/lib/table";
import { ListagemReservaResponse } from "core/features/reservas/typings";
import moment from "moment";
import { useMemo } from "react";
import {
  formatUnidadeBloco,
  getTagColor,
  getTypeTag,
} from "../../../util/helper";
import { formatMoney } from "infra/helpers/number";

function useListagemMensagensColumns({
  incluirColunaCondominio,
}: {
  incluirColunaCondominio?: boolean;
}) {
  return useMemo((): ColumnType<ListagemReservaResponse>[] => {
    const columns = [
      {
        title: "Data de criação",
        width: "110px",
        render: (original: ListagemReservaResponse) => (
          <Flex flexDir="column">
            <Text>{moment(original.createdAt).format("DD/MM/YYYY")}</Text>
            <Text>{moment(original.createdAt).format("HH:mm:ss")}</Text>
            {original.origem ? (
              <Box>
                <Tag rounded="full" variant="outline" colorScheme={"blue"}>
                  {original.origem.toLocaleUpperCase()}
                </Tag>
              </Box>
            ) : null}
          </Flex>
        ),
      },
      {
        title: "Data da Reserva",
        render: (original: ListagemReservaResponse) => (
          <Flex alignItems="center">
            <Text noOfLines={2}>
              {moment(original.data).format("DD/MM/YYYY")} às{" "}
              {original.horaInicio.slice(0, 5)}
            </Text>

            {/* {getIconForAreaComum(original.areaComum.id, false)} */}
          </Flex>
        ),
      },
      {
        title: "Área Comum",
        render: (original: ListagemReservaResponse) => (
          <Flex>
            <Text>{original.areaComum?.nome}</Text>
          </Flex>
        ),
      },
      {
        title: "Unidade",
        render: (original: ListagemReservaResponse) => (
          <Flex>
            <Text>
              {formatUnidadeBloco(
                original.unidade.numero,
                original.unidade.blocoQuadra
              )}
            </Text>
          </Flex>
        ),
      },
      {
        title: "Morador",
        render: (original: ListagemReservaResponse) => (
          <Flex flexDir="column">
            <Text>{original.nomeMorador}</Text>
          </Flex>
        ),
      },
      {
        title: "Status",
        render: (original: ListagemReservaResponse) => (
          <Flex flexDir="column">
            <Tag
              rounded="full"
              variant="outline"
              colorScheme={getTagColor(original.status.id)}
            >
              {getTypeTag(original.status.id)}
            </Tag>
            {original.valor ? (
              <Text fontWeight="bold">{formatMoney(original.valor)}</Text>
            ) : null}
          </Flex>
        ),
      },
    ];

    if (incluirColunaCondominio) {
      columns.push({
        title: "Condomínio",
        render: (original: ListagemReservaResponse) => (
          <Flex flexDir="column">
            <Text>{original.tenant?.nome}</Text>
          </Flex>
        ),
      });
    }

    return columns;
  }, [incluirColunaCondominio]);
}

export default useListagemMensagensColumns;
